// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#333","menuActiveText":"#bf291b"};